<form (ngSubmit)="submit()" class="needs-validation">
    <div class="inputs">
        <div class="input-group mb-3 runner-data">
            <span class="input-group-text" id="basic-addon1">Nom d'équipe</span>
            <input type="text" [formControl]="teamNameFC" class="form-control input-number" aria-label="team-label"
                aria-describedby="team-label">
            <div class="invalid-feedback">
                Veuillez saisir un nom d'équipe
            </div>
        </div>
        <div class="d-flex flex-md-row flex-column">
            <div class="input-group mb-3 runner-data">
                <span class="input-group-text" id="basic-addon1">Course</span>
                <select class="form-select" aria-label="Default select example" [formControl]="raceId">
                    @for (race of teamsRaces; track $index) {
                    <option [value]="race.id">{{race.name}}</option>
                    }

                </select>
            </div>
        </div>
        <div class="d-flex flex-md-row flex-column">
            <div class="input-group mb-3 runner-data aoe-pmd-r-2">
                <span class="input-group-text" id="basic-addon1">Catégorie</span>
                <input type="text" [formControl]="categoryTeamFC" class="form-control input-number"
                    aria-label="team-label" aria-describedby="team-label">
            </div>
            <div class="input-group mb-3 runner-data aoe-pmd-l-2">
                <span class="input-group-text" id="basic-addon1">Libellé
                    catégorie</span>
                <input type="text" [formControl]="categoryLabelTeamFC" class="form-control input-number"
                    aria-label="team-label" aria-describedby="team-label">
            </div>
        </div>

        <div class="d-flex flex-md-row flex-column">
            <div class="input-group mb-3 runner-data">
                <span class="input-group-text" id="basic-addon1">Statut</span>
                <select class="form-select" aria-label="Default select example" [formControl]="statutTeamFC">
                    @for (status of runnerStatus; track $index) {
                    <option [value]="status">{{runnerStatusLabel(status)}}</option>
                    }

                </select>
            </div>
        </div>
        <div class="d-flex flex-md-row flex-column">
            <div class="input-group mb-3 runner-data aoe-pmd-r-2">
                <span class="input-group-text" id="basic-addon1">Dossard</span>
                <input type="text" [formControl]="bibTeamFC" class="form-control input-number" aria-label="team-label"
                    aria-describedby="team-label">
            </div>
            <div class="input-group mb-3 runner-data aoe-pmd-l-2">
                <span class="input-group-text" id="basic-addon1">Puce</span>
                <input type="text" [formControl]="chipTeamFC" class="form-control input-number" aria-label="team-label"
                    aria-describedby="team-label">
            </div>
        </div>
        <div class="input-group mb-3 runner-data">
            <span class="input-group-text" id="basic-addon1">Club</span>
            <input type="text" [formControl]="clubFC" class="form-control input-number" aria-label="team-label"
                aria-describedby="team-label">
        </div>
    </div>

    <div class="d-flex flex-row justify-content-end">
        <button class="btn btn-primary" type="submit">Enregistrer</button>
    </div>

</form>